window.HF_VEHICLE_HARDWARE_RULES = [
  {
    make: "Jeep",
    model: "Wrangler",
    year_start: 2018,
    year_end: 2026,
    requires_hitch_extender: true,
    hitch_extender_reason: "rear spare tire",
    requires_extended_hitch_pin: false
  },
  {
    make: "Ford",
    model: "Bronco",
    year_start: 2021,
    year_end: 2026,
    requires_hitch_extender: true,
    hitch_extender_reason: "rear spare tire",
    requires_extended_hitch_pin: false
  },
  {
    make: "Mercedes-Benz",
    model: "Sprinter",
    year_start: 2010,
    year_end: 2026,
    requires_hitch_extender: true,
    hitch_extender_reason: "rear cargo doors",
    requires_extended_hitch_pin: false
  },
  {
    make: "Ford",
    model: "Transit",
    year_start: 2015,
    year_end: 2026,
    requires_hitch_extender: true,
    hitch_extender_reason: "rear cargo doors",
    requires_extended_hitch_pin: false
  },
  {
    make: "Ram",
    model: "ProMaster",
    year_start: 2014,
    year_end: 2026,
    requires_hitch_extender: true,
    hitch_extender_reason: "rear cargo doors",
    requires_extended_hitch_pin: false
  },
  {
    make: "Lexus",
    model: "GX 460",
    year_start: 2010,
    year_end: 2023,
    requires_hitch_extender: true,
    hitch_extender_reason: "side-hinged rear door",
    requires_extended_hitch_pin: false
  },
  {
    make: "Lexus",
    model: "GX 550",
    year_start: 2024,
    year_end: 2026,
    requires_hitch_extender: true,
    hitch_extender_reason: "side-hinged rear door",
    requires_extended_hitch_pin: false
  },
  {
    make: "Toyota",
    model: "Tacoma",
    year_start: 2024,
    year_end: 2026,
    requires_hitch_extender: false,
    hitch_extender_reason: null,
    requires_extended_hitch_pin: true
  },
  {
    make: "Toyota",
    model: "Tundra",
    year_start: 2022,
    year_end: 2026,
    requires_hitch_extender: false,
    hitch_extender_reason: null,
    requires_extended_hitch_pin: true
  },
  {
    make: "Rivian",
    model: "R1T",
    year_start: 2022,
    year_end: 2026,
    requires_hitch_extender: false,
    hitch_extender_reason: null,
    requires_extended_hitch_pin: true
  },
  {
    make: "Rivian",
    model: "R1S",
    year_start: 2023,
    year_end: 2026,
    requires_hitch_extender: false,
    hitch_extender_reason: null,
    requires_extended_hitch_pin: true
  }
];